import React from "react";
import "./Nav.css";
import NavBarLogoFinal from "../../media/NavBarLogoFinal.svg";
import { Button, Nav } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

interface SimpleNavProps {
  isMobile: boolean;
  isSidebarOpen: boolean;
  toggleSidebar: () => void;
  handleLogout: () => void;
}

const SimpleNav: React.FC<SimpleNavProps> = ({
  isMobile,
  isSidebarOpen,
  toggleSidebar,
  handleLogout,
}) => {
  const navigate = useNavigate();
  return (
    <div className={`sidebar ${isSidebarOpen ? "open" : "closed"}`}>
      {isMobile && (
        <div className="mobile-header">
          <div className="hamburger-button" onClick={toggleSidebar}>
            &#9776;
          </div>
          {isSidebarOpen && (
            <img
              src={NavBarLogoFinal}
              alt="Oxford Logo"
              className="sidebar-logo"
              // onClick={() =>
              //   window.open("https://www.oxforddoc.com/", "_blank")
              // }
            />
          )}
        </div>
      )}

      {isSidebarOpen && (
        <>
          {!isMobile && (
            <>
              <div className="sidebar-header">
                <img
                  src={NavBarLogoFinal}
                  alt="Oxford Logo"
                  className="sidebar-logo"
                  // onClick={() =>
                  //   window.open("https://www.oxforddoc.com/", "_blank")
                  // }
                />
              </div>
              <Nav className="flex-column">
                <Nav.Item>
                  <Button
                    onClick={handleLogout}
                    variant="outline-light"
                    className="signout-button"
                  >
                    Back to Login{" "}
                    <i className="bi bi-box-arrow-right sign-out-icon"></i>
                  </Button>
                </Nav.Item>
                <Nav.Item>
                  <Button
                    onClick={() =>
                      (window.location.href = "https://www.oxforddoc.com/")
                    }
                    variant="outline-light"
                    className="signout-button"
                  >
                    Back to Website{" "}
                    <i className="bi bi-box-arrow-right sign-out-icon"></i>
                  </Button>
                </Nav.Item>
                <Nav.Item className="mt-auto">
                  <Button
                    onClick={() => navigate("/help")}
                    variant="outline-light"
                    className="signout-button"
                  >
                    Contact Us/Need Help{" "}
                    <i className="bi bi-question-circle btn-icon"></i>
                  </Button>
                </Nav.Item>
              </Nav>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default SimpleNav;
